/* eslint-disable */
const $forms = $('.sb-forms') as any;
$forms.sb_lead_form({
	google_maps_api_key: 'AIzaSyCY2vZO2_wuLPaCaw6jcOPx5LDe4VmlGww',
	autofill_locations: true,
	route_zip: true,
});
/* eslint-enable */

// Prevent chat popup from popping when form is engaged.
document.addEventListener('focusin', (event) => {
	const target = event.target as HTMLElement;
	if (target.closest('.sb-forms')) {
		document.documentElement.classList.add('sb-form-focus');
	}
});

document.addEventListener('focusout', (event) => {
	const target = event.target as HTMLElement;
	if (target.closest('.sb-forms')) {
		document.documentElement.classList.remove('sb-form-focus');
	}
});
